var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ebook"},[(_vm.direction === 'horizontal')?_c('horizontal-ebook',{attrs:{"is-wx-env":_vm.isWxEnv}}):_vm._e(),(_vm.direction === 'vertical')?_c('vertical-ebook',{attrs:{"is-wx-env":_vm.isWxEnv}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }